import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const ProcessPosOrdersList = () => {
    // State for orders and filtered orders
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch orders when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}processposorders`)
            .then(response => response.json())
            .then(data => {
                setOrders(data.data);
                setFilteredOrders(data.data); // Set initial filtered orders
            })
            .catch(error => console.error('Error fetching processed POS orders:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter orders based on the search term
        const filtered = orders.filter(order =>
            order.order_no.toLowerCase().includes(term.toLowerCase()) ||
            order.name.toLowerCase().includes(term.toLowerCase()) ||
            order.item_name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredOrders(filtered);
    };

    // Navigate to the edit order page
    const handleEdit = (id) => {
        navigate(`/EditProcessPosOrder/${id}`);
    };

    // Handle order deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this order?")) {
            fetch(`${BASE_URL}processposorders/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        // Remove the deleted order from both lists (orders and filteredOrders)
                        setOrders(orders.filter(order => order.id !== id));
                        setFilteredOrders(filteredOrders.filter(order => order.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting order:', error));
        }
    };

    // Navigate to add new order page
    const handleAdd = () => {
        navigate('/AddProcessPosOrder');
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Processed POS Orders List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                    {/* Breadcrumbs can be added here */}
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        {/* Optionally, you can add a search filter here */}
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Order</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Order No, Name, or Item</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search order number, customer name, or item name"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Order No</th>
                                                <th>Order Date</th>
                                                <th>Customer</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>City</th>
                                                <th>State</th>
                                                <th>Item Code</th>
                                                <th>Item Name</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>Discount</th>
                                                <th>Total Discount</th>
                                                <th>Shipping</th>
                                                <th>Payment</th>
                                                <th>Billing Address</th>
                                                <th>Shipping Address</th>
                                                <th>Cancel Reason</th>
                                                <th>Tax Inclusive</th>
                                                <th>Currency</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredOrders.length > 0 ? (
                                                filteredOrders.map(order => (
                                                    <tr key={order.id}>
                                                        <td>{order.order_no}</td>
                                                        <td>{new Date(order.order_date).toLocaleString()}</td>
                                                        <td>{order.name} {order.last_name}</td>
                                                        <td>{order.email}</td>
                                                        <td>{order.phone}</td>
                                                        <td>{order.city}</td>
                                                        <td>{order.state}</td>
                                                        <td>{order.item_code}</td>
                                                        <td>{order.item_name}</td>
                                                        <td>{order.quantity}</td>
                                                        <td>{order.rate}</td>
                                                        <td>{order.amount}</td>
                                                        <td>{order.discount}</td>
                                                        <td>{order.total_discount}</td>
                                                        <td>{order.shipping}</td>
                                                        <td>{order.payment}</td>
                                                        <td>{order.billing_address}</td>
                                                        <td>{order.shipping_address}</td>
                                                        <td>{order.cancel_reason || 'N/A'}</td>
                                                        <td>{order.tax_inclusive ? 'Yes' : 'No'}</td>
                                                        <td>{order.currency}</td>
                                                        <td className="text-end">
                                                            <button className="btn btn-success" onClick={() => handleEdit(order.id)}>Edit</button>
                                                            <button className="btn btn-danger ms-2" onClick={() => handleDelete(order.id)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="22" className="text-center">No orders found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default ProcessPosOrdersList;
